<template>
    <div class="registrations">
        <div class="section4">
            <div
                class="card"
                :class="type == 'main-reg' ? 'bg-transparent' : 'bg-white'"
            >
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-12 text-center py-3">
                            <h2>REGISTER AS A DEALER</h2>
                        </div>
                    </div>
                    <form
                        method="post"
                        autocomplete="off"
                        enctype="multipart/form-data"
                        @submit.prevent="handleSubmit"
                    >
                        <div v-if="errorMsg" class="row py-3 text-center">
                            <div class="col-md-12">
                                <h5 class="text-danger">{{ errorMsg }}</h5>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group my-2">
                                    <input
                                        type="hidden"
                                        name="_token"
                                        :value="csrf"
                                    />
                                    <label
                                        class=""
                                        :class="
                                            type == 'main-reg'
                                                ? 'text-white'
                                                : 'text-muted'
                                        "
                                        >Company Name</label
                                    >
                                    <input
                                        type="text"
                                        v-model="form.name"
                                        id="name"
                                        name="name"
                                        class="form-control"
                                        :class="{
                                            'is-invalid':
                                                submitted &&
                                                v$.form.name.$error,
                                        }"
                                    />
                                    <span
                                        class="text-danger"
                                        v-if="v$.form.name.$errors"
                                    >
                                        {{ v$.form.name.$errors[0]?.$message }}
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group my-2">
                                    <label
                                        class=""
                                        :class="
                                            type == 'main-reg'
                                                ? 'text-white'
                                                : 'text-muted'
                                        "
                                        >Company Email</label
                                    >
                                    <input
                                        type="text"
                                        v-model="form.email"
                                        id="email"
                                        name="email"
                                        class="form-control"
                                        :class="{
                                            'is-invalid':
                                                submitted &&
                                                v$.form.email.$error,
                                        }"
                                    />
                                    <span
                                        class="text-danger"
                                        v-if="v$.form.email.$errors"
                                    >
                                        {{ v$.form.email.$errors[0]?.$message }}
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group my-2">
                                    <label
                                        class=""
                                        :class="
                                            type == 'main-reg'
                                                ? 'text-white'
                                                : 'text-muted'
                                        "
                                        >Address</label
                                    >
                                    <input
                                        type="text"
                                        v-model="form.address"
                                        id="address"
                                        name="address"
                                        class="form-control"
                                        :class="{
                                            'is-invalid':
                                                submitted &&
                                                v$.form.address.$error,
                                        }"
                                    />
                                    <span
                                        class="text-danger"
                                        v-if="v$.form.address.$errors"
                                    >
                                        {{
                                            v$.form.address.$errors[0]?.$message
                                        }}
                                    </span>
                                </div>
                            </div>
                            <!-- <div class="col-md-2">
                            <div class="form-group my-2">
                                <label class="text-muted">Unit</label>
                                <input type="text" v-model="form.unit" id="unit" name="unit" class="form-control" :class="{ 'is-invalid': submitted && v$.form.unit.$error }" />
                                <span class="text-danger" v-if="v$.form.unit.$errors"> {{ v$.form.unit.$errors[0]?.$message }} </span>
                            </div>
                        </div> -->
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group my-2">
                                    <label
                                        class=""
                                        :class="
                                            type == 'main-reg'
                                                ? 'text-white'
                                                : 'text-muted'
                                        "
                                        >City</label
                                    >
                                    <input
                                        type="text"
                                        v-model="form.city"
                                        id="city"
                                        name="city"
                                        class="form-control"
                                        :class="{
                                            'is-invalid':
                                                submitted &&
                                                v$.form.city.$error,
                                        }"
                                    />
                                    <span
                                        class="text-danger"
                                        v-if="v$.form.city.$errors"
                                    >
                                        {{ v$.form.city.$errors[0]?.$message }}
                                    </span>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group my-2">
                                    <label
                                        class=""
                                        :class="
                                            type == 'main-reg'
                                                ? 'text-white'
                                                : 'text-muted'
                                        "
                                        >State</label
                                    >
                                    <select
                                        name="state"
                                        class="form-control"
                                        v-model="form.state"
                                        placeholder="State"
                                        :class="{
                                            'is-invalid':
                                                submitted &&
                                                v$.form.state.$error,
                                        }"
                                    >
                                        <option value="AL">AL</option>
                                        <option value="AK">AK</option>
                                        <option value="AR">AR</option>
                                        <option value="AZ">AZ</option>
                                        <option value="CA">CA</option>
                                        <option value="CO">CO</option>
                                        <option value="CT">CT</option>
                                        <option value="DC">DC</option>
                                        <option value="DE">DE</option>
                                        <option value="FL">FL</option>
                                        <option value="GA">GA</option>
                                        <option value="HI">HI</option>
                                        <option value="IA">IA</option>
                                        <option value="ID">ID</option>
                                        <option value="IL">IL</option>
                                        <option value="IN">IN</option>
                                        <option value="KS">KS</option>
                                        <option value="KY">KY</option>
                                        <option value="LA">LA</option>
                                        <option value="MA">MA</option>
                                        <option value="MD">MD</option>
                                        <option value="ME">ME</option>
                                        <option value="MI">MI</option>
                                        <option value="MN">MN</option>
                                        <option value="MO">MO</option>
                                        <option value="MS">MS</option>
                                        <option value="MT">MT</option>
                                        <option value="NC">NC</option>
                                        <option value="NE">NE</option>
                                        <option value="NH">NH</option>
                                        <option value="NJ">NJ</option>
                                        <option value="NM">NM</option>
                                        <option value="NV">NV</option>
                                        <option value="NY">NY</option>
                                        <option value="ND">ND</option>
                                        <option value="OH">OH</option>
                                        <option value="OK">OK</option>
                                        <option value="OR">OR</option>
                                        <option value="PA">PA</option>
                                        <option value="RI">RI</option>
                                        <option value="SC">SC</option>
                                        <option value="SD">SD</option>
                                        <option value="TN">TN</option>
                                        <option value="TX">TX</option>
                                        <option value="UT">UT</option>
                                        <option value="VT">VT</option>
                                        <option value="VA">VA</option>
                                        <option value="WA">WA</option>
                                        <option value="WI">WI</option>
                                        <option value="WV">WV</option>
                                        <option value="WY">WY</option>
                                    </select>
                                    <span
                                        class="text-danger"
                                        v-if="v$.form.state.$errors"
                                    >
                                        {{ v$.form.state.$errors[0]?.$message }}
                                    </span>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group my-2">
                                    <label
                                        class=""
                                        :class="
                                            type == 'main-reg'
                                                ? 'text-white'
                                                : 'text-muted'
                                        "
                                        >Zip</label
                                    >
                                    <input
                                        type="text"
                                        v-model="form.zip_code"
                                        id="zip_code"
                                        name="zip_code"
                                        class="form-control"
                                        :class="{
                                            'is-invalid':
                                                submitted &&
                                                v$.form.zip_code.$error,
                                        }"
                                    />
                                    <span
                                        class="text-danger"
                                        v-if="v$.form.zip_code.$errors"
                                    >
                                        {{
                                            v$.form.zip_code.$errors[0]
                                                ?.$message
                                        }}
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group my-2">
                                    <label
                                        class="form-control-label"
                                        :class="
                                            type == 'main-reg'
                                                ? 'text-white'
                                                : 'text-muted'
                                        "
                                        for="password"
                                        >Password</label
                                    >
                                    <!-- <input
                                        type="password"
                                        v-model="form.password"
                                        id="confirmPassword"
                                        name="confirmPassword"
                                        class="form-control"
                                        :class="{
                                            'is-invalid':
                                                submitted &&
                                                v$.form.password.$error,
                                        }"
                                    />
                                    <span
                                        class="text-danger"
                                        v-if="v$.form.password.$errors"
                                    >
                                        {{
                                            v$.form.password.$errors[0]
                                                ?.$message
                                        }}
                                    </span> -->

                                    <input
                                        type="password"
                                        v-model="form.password"
                                        id="password"
                                        name="password"
                                        class="form-control"
                                        :class="{
                                            'is-invalid': submitted && v$.form.password.$error,
                                        }"
                                    />
                                    <!-- <span class="text-danger" v-if="v$.form.password.$errors">
                                        {{ v$.form.password.$errors[0]?.$message }}
                                    </span> -->
                                    <p v-if="v$.form.password.$error" class="text-danger m-0">Password must meet the following criteria:</p>
                                    <ul v-if="v$.form.password.$errors" class="text-danger">
                                        <li v-for="(item, idx) in v$.form.password.$errors" :key="idx">
                                            {{ item.$message }}
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group my-2">
                                    <label
                                        class="form-control-label"
                                        :class="
                                            type == 'main-reg'
                                                ? 'text-white'
                                                : 'text-muted'
                                        "
                                        for="confirm_password"
                                        >Confirm Password</label
                                    >
                                    <input
                                        type="password"
                                        v-model="form.confirm_password"
                                        id="confirmPassword"
                                        name="confirmPassword"
                                        class="form-control"
                                        :class="{
                                            'is-invalid':
                                                submitted &&
                                                v$.form.confirm_password.$error,
                                        }"
                                    />
                                    <span
                                        class="text-danger"
                                        v-if="v$.form.confirm_password.$errors"
                                    >
                                        {{
                                            v$.form.confirm_password.$errors[0]
                                                ?.$message
                                        }}
                                    </span>
                                </div>
                            </div>
                        </div>
                        <!-- // removed for now to fix the cloudlfare turnstile implementation -->
                        <!-- <div class="row">
                            <div class="col-md-12">
                                <div class="form-group my-2">
                                    <div class="cf-turnstile" data-theme="light" :data-sitekey="sitekey"></div>
                                </div>
                            </div>
                        </div> -->
                        <div class="row mt-3">
                            <div class="col-md-12">
                                <div class="form-group my-2 float-end">
                                    <a
                                        href="/login"
                                        class="btn btn-link pr-3"
                                        :class="
                                            type == 'main-reg'
                                                ? 'text-white'
                                                : 'text-dark'
                                        "
                                        >BACK TO LOG IN</a
                                    >

                                    <button
                                        type="submit"
                                        class="btn btn-register"
                                    >
                                        Register
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <div class="section5"></div>
        <div class="email-exist-container" v-if="showEmailExist">
            <div class="email-exist-inner">
                <div class="email-exist-text">
                    <p>
                        This email already has an account.<br />Please sign in,
                        or use another email address
                    </p>
                </div>
                <br />
                <div class="email-exist-btns">
                    <a href="/login" class="btn btn-link email-exist-signin"
                        >SIGN IN</a
                    >
                    <a
                        href="#"
                        class="btn btn-link email-exist-close"
                        @click="showEmailExist = false"
                        >Back to Registration&nbsp;
                        <i class="fa fa-arrow-right" aria-hidden="true"></i
                    ></a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { computed, onMounted } from "vue";
import { useStore, mapGetters } from "vuex";

import { useVuelidate } from "@vuelidate/core";
import {
    required,
    email,
    minLength,
    sameAs,
    requiredIf,
    helpers
} from "@vuelidate/validators";
import { passwordValidations } from "../helpers/passwordValidations";

export default {
    props: ["type","sitekey"],
    emits: [],
    components: {},
    setup() {
        const store = useStore();

        onMounted(() => {});

        return {
            store,
        };
    },
    data() {
        return {
            csrf: document.head.querySelector('meta[name="csrf-token"]')
                .content,
            v$: useVuelidate(),
            form: {
                name: null,
                email: null,
                address: null,
                city: null,
                state: null,
                zip_code: null,
                password: null,
                confirm_password: null,
            },
            submitted: false,
            showEmailExist: false,
            errorMsg: null

        };
    },
    computed: {},
    validations() {
        return {
            form: {
                name: { required },
                email: { required, email },
                address: { required },
                city: { required },
                state: { required },
                zip_code: { required },
                password: {
                    ...passwordValidations,
                },
                confirm_password: {
                    required,
                    sameAsPassword: sameAs(this.form.password),
                },
            },
        };
    },
    mounted() {
        console.log(this.csrf);
        console.log(this.site_key);
        console.log(this.sitekey);
    },
    methods: {
        handleSubmit(e) {
            const token = $('input[name=cf-turnstile-response]').val();
            this.submitted = true;

            this.v$.$validate();
            if (!this.v$.$error) {
                // removed for now to fix the cloudlfare turnstile implementation
                // check if email exist
                // axios
                //     .post("/api/validate-token", {
                //         token: token,
                //     })
                //     .then((response) => {
                //         // if ANY fail validation
                //         if (response.data.status == 'success') {
                //             this.errorMsg = null
                //             // this.register();

                //             window.emitter.emit("changeLoaderStatus", true);
                //             axios
                //                 .post("/api/register-dealer", this.form)
                //                 .then((data) => {
                //                     window.emitter.emit("changeLoaderStatus", false);
                //                     window.location.href = "/message";
                //                 })
                //                 .catch((error) => {
                //                     console.log('error',error)
                //                     this.showEmailExist = true;
                //                 });

                //         } else {
                //             this.errorMsg = response.data.message;
                //         }
                        
                //     })
                //     .catch((error) => {
                //     });

                window.emitter.emit("changeLoaderStatus", true);
                axios
                    .post("/api/register-dealer", this.form)
                    .then((data) => {
                        window.emitter.emit("changeLoaderStatus", false);
                        window.location.href = "/message";
                    })
                    .catch((error) => {
                        console.log('error',error)
                        this.showEmailExist = true;
                    });

            } else {
                // alert('Form failed validation')
            }
        },
        register() {
            this.store.dispatch("registerDealer", this.form);
        },
        isNotCommonPassword(value) {
            const commonPasswords = [
                'qwertyuiop', '1234567890', 'q1w2e3r4t5', '1q2w3e4r5t', '4815162342', '12345qwert',
                '123456789a', '1234554321', 'Usuckballz1', '1111111111', '123456789q', '1029384756',
                'password123', 'basketball', 'Soso123aljg', '123qweasdzxc', '12345678910', 'manchester',
                '1qaz2wsx3edc', 'q1w2e3r4t5y6', '1123581321', '1q2w3e4r5t6y', 'qwerty12345', '1234512345',
                'Mailcreated5240', '1122334455', 'nuttertools', 'qazwsxedcrfv', 'fuck_inside', '123456qwerty',
                '1234567890q', 'qwerty123456', '5555555555', 'terminator', '9876543210', 'california',
                'enterprise', 'rjirfrgbde', '123456789z', 'poiuytrewq', 'Sojdlg123aljg', 'Translator',
                'fktrcfylhf', 'deepthroat', 'multiplelo', 'christopher', 'undertaker', 'a123456789',
                'motherlode', 'sersolution', 'qwerty1234', 'montgom240', 'salamander', 'qwertyqwerty',
                '1.23457E+11', 'syncmaster', 'aleksandra', 'rjycnfynby', 'tinkerbell', 'motherfucker',
                'ghostrider', 'realmadrid', 'PolniyPizdec0211', '1357924680', '7uGd5HIp2J', 'playstation',
                'leavemealone', 'dragonball', '1234567890a', 'microphone', 'gfhjkmgfhjkm', '1234567891',
                'vSjasnel12', 'strawberry', 'washington', '9293709b13', 'yjdsqgfhjkm', 'qazwsxedc123',
                'fuckinside', 'Good123654', '7894561230', 'harrypotter', 'zxcvbnm123', 'mypassword',
                'alessandro', 'abrakadabra', '7777777777', '123456789s', 'underground', 'ghjcnjgfhjkm',
                'password12', 'anastasiya', 'zxcasdqwe123', 'qwert12345', 'pufunga7782', 'highlander',
                'ghhh47hj7649', 'Password123', 'konstantin', 'intercourse', '9999999999', '2222222222',
                '3333333333', '4444444444', '6666666666', '8888888888', '0'
            ];
            return !commonPasswords.includes(value);
        }
    },
};
</script>
<style scoped>
.email-exist-container {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    right: 0;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    padding-top: 10%;
    background: rgb(0 0 0 / 61%);
}
.email-exist-inner {
    display: block;
    margin-left: auto;
    margin-right: auto;
    max-width: 500px;
    background: #c1c1c1;
    padding: 90px 30px;
    width: 90%;
}
.email-exist-text {
    text-align: center;
    color: black;
    font-weight: 800;
    font-family: "TT-Norms-ExtraBold";
    font-size: 20px;
}

.email-exist-btns {
    display: flex;
    justify-content: center;
    gap: 5px;
}
.email-exist-signin {
    color: white;
    background: #ff7f00;
    text-decoration: none;
    font-weight: 700;
    font-family: "TT-Norms-ExtraBold";
    padding: 5px 35px;
}

.email-exist-close {
    color: black;
    text-decoration: none;
    font-family: "TT-Norms-ExtraBold";
}
</style>
